module.exports = __webpack_public_path__ + "static/img/1.b72dee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/1.png
// module id = vVFS
// module chunks = 1